//上传接口
import { post, get, postJson, put ,deleteApi,imagePost} from '../axios2'

const RESOURCE_BASE_PATH = '/image'

//上传图片
export const uploadImage = p => imagePost(`${RESOURCE_BASE_PATH}/upload`, p);

